import{useLayoutEffect as o,useEffect as r}from"react";import e from"../utils/isBrowser.js";var f=e?o:r,t=f;export{t as default};
//# sourceMappingURL=index.js.map
